module.exports = __webpack_public_path__ + "img/pro_two_1.23380c2f.jpg";